import { defineMessages } from 'react-intl';

export const scope = 'doc_types';

export default defineMessages({
    doctype_exists: {
        id: `${scope}.doctype_exists`,
        defaultMessage: 'A document type with this name already exists.',
    },
    doctype_name_check: {
        id: `${scope}.doctype_name_check`,
        defaultMessage: 'Please choose a different name.',
    },
    doctype_add_error: {
        id: `${scope}.doctype_add_error`,
        defaultMessage: 'Failed to create document type.',
    },
    invalid_doctype: {
        id: `${scope}.invalid_doctype`,
        defaultMessage: 'The selected document type is not valid. Please try a different one.',
    },
    file_selection_error: {
        id: `${scope}.file_selection_error`,
        defaultMessage: 'Please select a file and try again.',
    }
});
